




import { Component, Mixins, Prop } from "vue-property-decorator";
import { Document, DocumentParameterContainer } from "../../../domain/document";
import { DocumentEditViewMixin } from "../mixins";
import { default as DocumentProcessor } from "./DocumentProcessor.vue";

/**
 * まだどこからも参照されてなくて未使用
 */
@Component({
  components: {
    DocumentProcessor,
  },
})
export default class DocumentsProcessor extends Mixins(DocumentEditViewMixin) {
  @Prop()
  process: (source: Document) => Promise<number>;

  @Prop()
  emptyHisKeys: string[];

  $refs!: {
    processor: DocumentProcessor,
  };

  async processDocuments(documentIds: number[], intervalMilliSeconds: number, orderNo: string, parameterContainer: DocumentParameterContainer): Promise<number> {
    this._validateOrderNo(documentIds, orderNo);
    return this._processDocuments(
      documentIds,
      intervalMilliSeconds,
      async i => this.$refs.processor.processDocument(await this.loadInitializedExistingDocument(this.patientNo, i, orderNo, parameterContainer)));
  }

  private _validateOrderNo(documentIds: number[], orderNo: string): void {
    if (orderNo && (1 < documentIds.length)) {
      throw new Error("オーダNoが指定されてるのに文書IDが複数指定されています.");
    }
  }

  private async _processDocuments(documentIds: number[], intervalMilliSeconds: number, processDocument: (documentId: number) => Promise<number>): Promise<number> {
    if (!documentIds) {
      throw new Error("文書IDが指定されていません.指定してください.");
    }
    this.$logger.info("既存文書を処理します.(" + documentIds.length + "文書)");
    let count = 0;
    let isFirst = true;
    for (const id of documentIds) {
      if (!isFirst && intervalMilliSeconds > 0) {
        await this.$sleep(intervalMilliSeconds);
      }
      try {
        const documentId = await processDocument(id);
        count++;
        this.$logger.info("既存文書を処理しました.(文書ID:" + documentId + ")");
      } catch (e) {
        this.$logger.error(e.message);
        this.$logger.error("既存文書処理中に問題が発生しました.当該文書の処理をスキップします.");
      }
      isFirst = false;
    }
    this.$logger.info("既存文書を処理しました.(" + count + "文書)");
    return count;
  }
}
